import { CdpEventParameters } from "./typeDefinitions";

export class CdpEvent {
  event = 'cdp data' as const;
  parameters: CdpEventParameters;

  constructor(cdpData: CdpEventParameters) {
    this.parameters = cdpData;
  }
}